import React from "react";
import Media from "react-media";
import Mobile from "./Mobile";
import Desktop from "./Desktop";

export default () => {
  return <Media query="(min-width: 960px)">{matches => (matches ? <Desktop /> : <Mobile />)}</Media>;
};
